export var ValidationStates;
(function (ValidationStates) {
    ValidationStates["Error"] = "error";
    ValidationStates["Success"] = "success";
})(ValidationStates || (ValidationStates = {}));
